import { IPredictedLineupsDetail } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const PredictedLineupsDetailWrapper = React.lazy(() => import('./match-predicted-lineups'));

export interface IDynamicPredictedLineupsDetail extends IComponentModel<IPredictedLineupsDetail> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
  headshothash?: string;
}

const DynamicPredictedLineupsDetail = ({
  /* istanbul ignore next: default value */ model = {} as IPredictedLineupsDetail,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
  headshothash = undefined,
}: IDynamicPredictedLineupsDetail) => {
  return (
    <Suspense fallback={<HtmlWrapper html={children} />}>
      <PredictedLineupsDetailWrapper
        live={live}
        initialModel={validateModel(model) as IPredictedLineupsDetail}
        query={validateModel(query)}
        headshothash={headshothash}
      />
    </Suspense>
  );
};

DynamicPredictedLineupsDetail.defaultProps = {
  headshothash: undefined,
};

export default DynamicPredictedLineupsDetail;
